import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.min.js'
import './css/main.css'
import './Footer.css';
import Img_1 from './image/mapsicon.png';
import Img_2 from './image/linkedin.png';
import Img_3 from './image/companyicon.png';
import React from 'react';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();

  return (
    <span id="footer">
      <div class="vb-footer-box">
        <div class="container vb-footer-content">
          <div class="row gy-4">
            <div class="col-lg-5 col-md-12">
              <h6 class="vb-footer-title">{t('footer.company')}</h6>
              <p class="vb-footer-text">{t('footer.description')}</p>
            </div>

            <div class="col-lg-3 col-md-6">
              <h6 class="vb-footer-title">{t('footer.navigation')}</h6>
              <ul class="vb-footer-links">
                <li><a href="/home">{t('nav.home')}</a></li>
                <li><a href="/about">{t('nav.about')}</a></li>
                <li><a href="/contact">{t('nav.contact')}</a></li>
              </ul>
            </div>

            <div class="col-lg-4 col-md-6">
              <h6 class="vb-footer-title">{t('footer.contact')}</h6>
              <div class="vb-footer-item">
                <span class="vb-footer-icon-slot">
                  <a href="https://maps.app.goo.gl/k6ZEPuRKGRGtSW6d6" target="_blank" rel="noreferrer"><img class="vb-icon" src={Img_1} alt="Adres locatie"></img></a>
                </span>
                <p>{t('footer.address')}</p>
              </div>
              <div class="vb-footer-item">
                <span class="vb-footer-icon-slot">
                  <img class="vb-icon" src={Img_3} alt="Bedrijfsnummer"></img>
                </span>
                <p>{t('footer.kvk')}</p>
              </div>
              <div class="vb-footer-item">
                <span class="vb-footer-icon-slot">
                  <a href="https://www.linkedin.com/company/vb-control/" target="_blank" rel="noreferrer"><img class="vb-icon" src={Img_2} alt="LinkedIn"></img></a>
                </span>
                <p>info@vbcontrol.com</p>
              </div>
            </div>
          </div>

          <div class="vb-footer-bottom">
            <p>{t('footer.rights')}</p>
          </div>
        </div>
      </div>
    </span>
  );
}

export default Footer;
